<section class="integrations-overview">
    <h2 class="section-title">{{ 'aumico_integrations_section_available' | i18next }}</h2>

    <div class="cards-grid">
        <aumico-vendor-integration-card
            *ngFor="let vendor of vendors; trackBy: trackByVendor"
            [vendor]="vendor"
            [connected]="(vendorStates[vendor.vendor] | async)?.connected ?? false"
            [needsAction]="(vendorStates[vendor.vendor] | async)?.needsAction ?? false"
            [badgeKey]="(vendorStates[vendor.vendor] | async)?.badgeKey ?? null"
            [badgeVariant]="(vendorStates[vendor.vendor] | async)?.badgeVariant ?? 'connected'"
            (infoClick)="onInfo(vendor)"
        ></aumico-vendor-integration-card>
    </div>
</section>

<!-- Per-company vendor (Bexio) on the Org Settings: info modal pointing to the company. -->
<aumico-vendor-org-redirect-modal
    *ngIf="activeRedirectVendor != null"
    [vendor]="activeRedirectVendor"
    (closed)="onRedirectModalClosed()"
></aumico-vendor-org-redirect-modal>

<!-- Connect-Modal — vendor-specific. -->
<aumico-d365bc-connect-modal
    *ngIf="activeConnectVendor === IntegrationVendor.D365_BC"
    (closed)="onConnectModalClosed()"
></aumico-d365bc-connect-modal>

<aumico-abacus-connect-modal
    *ngIf="activeConnectVendor === IntegrationVendor.ABACUS"
    (closed)="onConnectModalClosed()"
></aumico-abacus-connect-modal>

<aumico-topal-connect-modal
    *ngIf="activeConnectVendor === IntegrationVendor.TOPAL"
    (closed)="onConnectModalClosed()"
></aumico-topal-connect-modal>

<aumico-accounto-connect-modal
    *ngIf="activeConnectVendor === IntegrationVendor.ACCOUNTO"
    (closed)="onConnectModalClosed()"
></aumico-accounto-connect-modal>

<aumico-proffix-connect-modal
    *ngIf="activeConnectVendor === IntegrationVendor.PROFFIX"
    (closed)="onConnectModalClosed()"
></aumico-proffix-connect-modal>

<!-- SharePoint (REV-21860): per-org document source. Same connect/manage routing as the
     accounting vendors — `onInfo` sends a per-org vendor to manage when it already has a
     connection, else to connect. -->
<aumico-sharepoint-connect-modal
    *ngIf="activeConnectVendor === IntegrationVendor.SHAREPOINT"
    (closed)="onConnectModalClosed()"
></aumico-sharepoint-connect-modal>

<!-- Manage-Modal — vendor-specific. -->
<aumico-d365bc-manage-modal
    *ngIf="activeManageVendor === IntegrationVendor.D365_BC"
    [initialConnectionId]="manageModalInitialConnectionId"
    (closed)="onManageModalClosed()"
    (requestAddTenant)="onAddTenantRequested(IntegrationVendor.D365_BC)"
></aumico-d365bc-manage-modal>

<aumico-abacus-manage-modal
    *ngIf="activeManageVendor === IntegrationVendor.ABACUS"
    [initialConnectionId]="manageModalInitialConnectionId"
    (closed)="onManageModalClosed()"
    (requestAddServer)="onAddTenantRequested(IntegrationVendor.ABACUS)"
    (requestEditMapping)="onAbacusEditMapping($event)"
></aumico-abacus-manage-modal>

<aumico-topal-manage-modal
    *ngIf="activeManageVendor === IntegrationVendor.TOPAL"
    [initialConnectionId]="manageModalInitialConnectionId"
    (closed)="onManageModalClosed()"
    (requestAddServer)="onAddTenantRequested(IntegrationVendor.TOPAL)"
></aumico-topal-manage-modal>

<aumico-accounto-manage-modal
    *ngIf="activeManageVendor === IntegrationVendor.ACCOUNTO"
    [initialConnectionId]="manageModalInitialConnectionId"
    (closed)="onManageModalClosed()"
    (requestAddServer)="onAddTenantRequested(IntegrationVendor.ACCOUNTO)"
></aumico-accounto-manage-modal>

<aumico-proffix-manage-modal
    *ngIf="activeManageVendor === IntegrationVendor.PROFFIX"
    [initialConnectionId]="manageModalInitialConnectionId"
    (closed)="onManageModalClosed()"
    (requestAddServer)="onAddTenantRequested(IntegrationVendor.PROFFIX)"
></aumico-proffix-manage-modal>

<aumico-sharepoint-manage-modal
    *ngIf="activeManageVendor === IntegrationVendor.SHAREPOINT"
    [initialConnectionId]="manageModalInitialConnectionId"
    (closed)="onManageModalClosed()"
    (requestAddConnection)="onAddTenantRequested(IntegrationVendor.SHAREPOINT)"
></aumico-sharepoint-manage-modal>

<!-- Abacus mapping modal: stacks on top of the manage modal when the user
     clicks "+ Mapping hinzufügen" or "Bearbeiten" on a row. -->
<aumico-abacus-mapping-modal
    *ngIf="abacusMapping != null"
    [connectionId]="abacusMapping.connectionId"
    [aumicoCompanyId]="abacusMapping.aumicoCompanyId"
    (closed)="onAbacusMappingClosed()"
></aumico-abacus-mapping-modal>

<!-- Single edit modal: opens when the manage modal asks for re mapping a
     specific BC company. Driven by the `singleEdit` NgRx slice. -->
<aumico-company-mapping-modal *ngIf="singleEditActive$ | async"></aumico-company-mapping-modal>
